
import AppRouting from './Routing/AppRouting';
import 'bootstrap/dist/css/bootstrap.min.css';

// import './Assets/css/bootstrap-select.min.css'
// import './Assest/css/bootstrap-slider.min.css'
// import './Assest/css/bootstrap.min.css'
// import './Assest/css/bootstrap4-toggle.min.css'
// import './Assest/css/dataTables.bootstrap4.min.css'
// import './Assest/css/css/dropzone.css'
function App() {

  return (
    <>
      <AppRouting />
    </>
  );
}

export default App;
